import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDevices2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="devices-2, macbook, iphone, phone, connected"><path d="M15.75 9.75L22.25 9.75V20.25H15.75V9.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.5 19.75H1.75V15.75H13.5" stroke="currentColor" strokeWidth="1.5"/><path d="M20.25 7.5V3.75H3.75V15.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconDevices2;
